var map = {
	"./arrow-down-blue.svg": 505,
	"./arrow-down-grey.svg": 506,
	"./arrow-right-white.png": 507,
	"./arrow-right.svg": 508,
	"./blue-loader.svg": 238,
	"./circle-grey.svg": 509,
	"./circle.svg": 510,
	"./coinbaseWalletIcon.svg": 146,
	"./dropdown-blue.svg": 511,
	"./dropdown.svg": 512,
	"./dropup-blue.svg": 513,
	"./ethereum-logo.png": 239,
	"./fortmaticIcon.png": 514,
	"./link.svg": 515,
	"./magnifying-glass.svg": 516,
	"./menu.svg": 517,
	"./metamask.png": 237,
	"./plus-blue.svg": 518,
	"./plus-grey.svg": 519,
	"./portisIcon.png": 520,
	"./question-mark.svg": 521,
	"./question.svg": 522,
	"./spinner.svg": 523,
	"./token-list-logo.png": 524,
	"./token-list/lists-dark.png": 525,
	"./token-list/lists-light.png": 526,
	"./trustWallet.png": 527,
	"./walletConnectIcon.svg": 147,
	"./x.svg": 528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;